export default "__VITE_ASSET__BQwntSc___"